import React from 'react'
import About from './About'
import Projects from './Projects'
import Education from './Education'
import Contact from './Contact'
import Work from './Work'

const Body = () => {
  return (
    <div>
      <About/>
      <Education/>
      <Work/>
      <Projects/>
      <Contact/>
    </div>
  )
}

export default Body
